export default {"src":"/_next/static/media/food.00f26776.svg","height":25,"width":28,"blurWidth":0,"blurHeight":0};